import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export interface ChannelSelectionProps {
  id: number;
  label: string;
  name: string;
}

interface Props {
  options: ChannelSelectionProps[] | undefined;
  error: boolean;
}

// Define the initial state using that type
const initialState: Props = {
  options: [],
  error: false,
};

export const channelsSlice = createSlice({
  name: 'channels',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setChannels: (state, action: PayloadAction<ChannelSelectionProps[] | null>) => {
      state.options = action.payload ?? [];
      state.error = state.options && state.options.length === 0;
    },
  },
});

export const { setChannels } = channelsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectChannelOptions = (state: RootState) => state.channels.options;
export const selectChannelError = (state: RootState) => state.channels.error;

export default channelsSlice.reducer;
